// import { BsThreeDots } from "react-icons/bs";
// import { useDispatch } from "react-redux";
// import { Link } from "react-router-dom";
// import {
//     setSelectedFriend,
//     toggleFriendActionModal,
// } from "../../redux/slicers/friendModalSlicer";
// import Avatar from "../avatar/Avatar";
// import FollowBtn from "../button/FollowBtn";
// import { MessageBtn } from "../button/MessageBtn";
// import "./UserCard.css";
// import { IonAvatar, IonButton, IonCard, IonCardContent, IonIcon, IonLabel } from "@ionic/react";
// import { ellipsisHorizontal } from "ionicons/icons";

// const UserCard = ({ user }) => {
//     const dispatch = useDispatch();

//     const handleClick = (e) => {
//         e.preventDefault();
//         dispatch(
//             setSelectedFriend({
//                 ...user,
//             })
//         );
//         dispatch(toggleFriendActionModal());
//     };

//     return (
//         // <div className="user-card">
//         //     <div className="display-flex justify-content-sb align-items-c flex-1">
//         //         <div className="display-flex align-items-c gap-2">
//         //             <Avatar username={user.username} avatar={user.avatar} size="small" />
//         //             <div className="display-flex flex-col">
//         //                 <Link
//         //                     className="display-flex align-items-c gap-2"
//         //                     to={`/profile/${user.username}`}
//         //                 >
//         //                     <p className="user-name">{user.fname}</p>
//         //                     <p className="user-username">@{user.username}</p>
//         //                 </Link>
//         //                 <div className="display-flex align-items-c gap-2">
//         //                     <MessageBtn userId={user._id} />
//         //                     <FollowBtn user={user} />
//         //                 </div>
//         //             </div>
//         //         </div>

//         //         <div className="display-flex align-items-c gap-2">
//         //             <BsThreeDots className="post-btns__btn" onClick={handleClick} />
//         //         </div>
//         //     </div>
//         // </div>
//         <IonCard className="user-card">
//             <IonCardContent>
//                 <div className="user-card-header">
//                     <div className="user-info-section">
//                         <IonAvatar slot="start">
//                             <Avatar username={user.username} avatar={user.avatar} size="small" />
//                         </IonAvatar>
//                         <div className="user-details">
//                             <Link
//                                 className="user-link"
//                                 to={`/profile/${user.username}`}
//                             >
//                                 <IonLabel>
//                                     <h3 className="user-name">{user.fname}</h3>
//                                     <p className="user-username">@{user.username}</p>
//                                 </IonLabel>
//                             </Link>
//                         </div>
//                     </div>

//                     <IonButton
//                         fill="clear"
//                         size="small"
//                         onClick={handleClick}
//                         className="options-button"
//                     >
//                         <IonIcon icon={ellipsisHorizontal} />
//                     </IonButton>
//                 </div>

//                 <div className="user-actions">
//                     <MessageBtn userId={user._id} />
//                     <FollowBtn user={user} />
//                 </div>
//             </IonCardContent>
//         </IonCard>
//     );
// };

// export default UserCard;

import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import {
  setSelectedFriend,
  toggleFriendActionModal,
} from "../../redux/slicers/friendModalSlicer";
import Avatar from "../avatar/Avatar";
import FollowBtn from "../button/FollowBtn";
import { MessageBtn } from "../button/MessageBtn";
import {
  IonCard,
  IonCardContent,
  IonItem,
  IonAvatar,
  IonLabel,
  IonButton,
  IonIcon,
} from "@ionic/react";
import { ellipsisHorizontal, eye } from "ionicons/icons";
import "./UserCard.css";
import { truncate } from "../../utils/truncate";

const UserCard = ({ user }) => {
  const dispatch = useDispatch();

  const handleOptionsClick = (e) => {
    e.preventDefault();
    dispatch(setSelectedFriend(user));
    dispatch(toggleFriendActionModal());
  };

  return (
    <IonCard className="user-card">
      <IonCardContent>
        <div className="user-item">
          <Avatar
            username={user.username}
            avatar={user.avatar}
            province={user.province}
            size="large"
            isOfficial={user.isAdmin}
          />
          <div className="user-info">
            <Link to={`/profile/${user.username}`} className="user-link">
              <h3 className="user-name">{user.fname}</h3>
              <p className="user-username">@{user.username}</p>
              <span>
                {[user.city, user.province].filter(Boolean).join(", ")}
              </span>
            </Link>
          </div>
          <IonButton
            fill="clear"
            size="small"
            onClick={handleOptionsClick}
            className="options-button"
          >
            <IonIcon icon={ellipsisHorizontal} />
          </IonButton>
        </div>
        <p className="user-bio">{truncate(user.bio, 80)}</p>
        <div className="user-actions">
          <MessageBtn userId={user._id} />
          <FollowBtn user={user} />
        </div>
      </IonCardContent>
    </IonCard>
  );
};

export default UserCard;
